import { Component, OnInit } from '@angular/core';
import { RouteService } from '../../service/route/route.service';
import { Route } from '../../class/route';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-routes',
  templateUrl: './routes.component.html',
  styleUrls: ['./routes.component.scss']
})
export class RoutesComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public routes: Route[];
    public selectRoute: Route;
    public userID: Number = 0;
    public modNew = false;
    public modView = false;
    public openRoute = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public form3: FormGroup;
    public first = 0;
    public filters: {key: string, value: string}[];

    public station_id_filter: AbstractControl;
    public employee_id_filter: AbstractControl;

    public employeePositionToEmployeeAuxiliar: string;

    constructor(
        fb: FormBuilder,
        public routeService: RouteService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) {

          this.employeePositionToEmployeeAuxiliar = '2';

          this.form3 = fb.group({
            'station_id_filter': [''],
            'employee_id_filter': [''],
          });
          this.station_id_filter = this.form3.controls['station_id_filter'];
          this.employee_id_filter = this.form3.controls['employee_id_filter'];

        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        //this.getRoutes();
    }

    public loadRoutesLazy(event: LazyLoadEvent) {
      this.page = (event.first / this.per_page) + 1;
      if (event.sortOrder === -1) {
          this.sort =  '-' + event.sortField;
      } else {
          this.sort =  event.sortField;
      }
      if (event.globalFilter) {
          this.query = event.globalFilter;
      } else {
          this.query = undefined;
      }

      this.sort = '-id';

      this.filter();
    }

    public getRoutes() {
        this.routeService.getRoute(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.routes = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newRoute() {
        this.modNew = !this.modNew;
        this.selectRoute = null;
    }

    public savedRoute(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectRoute = null;
        this.modNew = false;
        this.getRoutes();
    }

    public cancelRoute (res) {
        this.selectRoute = null;
        this.modNew = false;
        this.modView = false;
        this.getRoutes();
    }

    public edit(user: Route) {
        this.modNew = true;
        this.selectRoute = user;
        this.getRoutes();
    }

    public view(user: Route) {
        this.openRoute = true;
        this.selectRoute = user;
        this.userID = user.id;
        this.modView = true;
    }

    public deleteDialog(user: Route) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(user);
            }
        });
    }

    public delete(user: Route) {
        this.routeService.deleteRoute(user.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getRoutes();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeRoute(user: Route) {
        this.putRoute(user);
    }

    public putRoute(values: Route) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.routeService.updateRoute(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public filter (values?, pageRefresh?) {
      if (pageRefresh) {
        this.page = 1;
        this.first = 0;
        this.per_page = 10;
      }
      if (values) {
        this.filters = [];
        if (values.station_id_filter) {
          this.filters.push({'key': 'station_id-lk', 'value': values.station_id_filter.id});
        }
        if (values.employee_id_filter) {
          this.filters.push({'key': 'employee_id-in', 'value': values.employee_id_filter.id});
        }
      }
      this.getRoutes();
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/routes/routes.component.ts